module.exports = __webpack_public_path__ + "static/media/product.d11e5382.png";